// @flow

import compact from 'lodash/compact';
import range from 'lodash/range';
import moment from 'moment';
import { isFutureDate } from 'clark-utils';
import { isRequired, isTime, normalizeTime } from '@clark-inc/clark-forms';
import { isScheduling } from './helpers';

type DropdownOptionsType = Array<{ label: string, value: string }>;

export const generateFieldset = (
  engagementDropdownOptions: DropdownOptionsType,
  dispatchToggleIsRecurring: () => void,
  isRecurring: boolean,
  startTime: moment,
) => {
  const shouldToggleIsRecurring = isRecurring && !isFutureDate(startTime);
  const engagementSelect = engagementDropdownOptions.length
    ? {
        columns: { small: 1, large: 1 },
        fields: [
          {
            type: 'dropdown',
            name: 'tutoringEngagementId',
            label: 'Student',
            values: engagementDropdownOptions,
            validate: [isRequired],
          },
        ],
      }
    : {
        columns: { small: 1, large: 1 },
        fields: [
          {
            type: 'dropdown',
            name: 'tutoringEngagementId',
            label: 'Student',
            disabled: true,
            values: [{ value: null, label: 'No students' }],
            validate: [isRequired],
          },
        ],
      };

  // $FlowFixMe
  const fieldSet = compact([
    engagementSelect,
    {
      columns: { small: 1, large: 1 },
      fields: [
        {
          type: 'datepicker',
          name: 'startDate',
          label: 'Date',
          showTimeSelect: true,
          dateFormat: 'LLL',
          validate: [isRequired],
          isOutsideRange: () => false,
          onChange: shouldToggleIsRecurring ? dispatchToggleIsRecurring : null,
        },
      ],
    },
    {
      columns: { small: 2, large: 2 },
      fields: [
        {
          type: 'input',
          name: 'startTime[time]',
          label: 'Start',
          placeholder: '12:00',
          normalize: normalizeTime,
          validate: [isRequired, isTime],
        },
        {
          type: 'toggleButton',
          name: 'startTime[period]',
          values: [{ label: 'AM', value: 'am' }, { label: 'PM', value: 'pm' }],
          validate: isRequired,
        },
      ],
    },
    {
      columns: { small: 2, large: 2 },
      fields: [
        {
          type: 'input',
          name: 'endTime[time]',
          label: 'End',
          placeholder: '12:00',
          normalize: normalizeTime,
          validate: [isRequired, isTime],
          onChange: shouldToggleIsRecurring ? dispatchToggleIsRecurring : null,
        },
        {
          type: 'toggleButton',
          name: 'endTime[period]',
          values: [{ label: 'AM', value: 'am' }, { label: 'PM', value: 'pm' }],
          validate: isRequired,
          onChange: shouldToggleIsRecurring ? dispatchToggleIsRecurring : null,
        },
      ],
    },
  ]);

  return [
    {
      fieldSet,
    },
  ];
};

export const generateRecurrenceFieldset = (
  sessionDate: ?moment,
  isRecurring: boolean,
  dispatchToggleIsCancelation: () => void,
) => {
  const recurrenceDropdownOptions = range(2, 25).map(r => ({
    value: r,
    label: `${r} weeks`,
  }));

  // $FlowFixMe
  const fieldSet = compact([
    {
      columns: { small: 1, large: 1 },
      fields: [
        {
          type: 'checkbox',
          name: 'isRecurring',
          label: `Repeat every ${moment(sessionDate).format('dddd')}`,
          onChange: dispatchToggleIsCancelation,
        },
      ],
    },
    isRecurring
      ? {
          columns: { small: 1, large: 1 },
          fields: [
            {
              type: 'dropdown',
              name: 'sessionRecurrenceCount',
              label: 'For the next',
              values: recurrenceDropdownOptions,
              validate: [isRequired],
            },
          ],
        }
      : undefined,
  ]);

  return [
    {
      fieldSet,
    },
  ];
};

export const generateSecondaryFieldset = (
  isRecurring: boolean,
  sessionDate: ?moment,
  endTime: ?{ time: string, period: string },
) => {
  const internalNotes =
    isScheduling(sessionDate, endTime) && !isRecurring
      ? {
          columns: { small: 1, large: 1 },
          fields: [
            {
              type: 'textarea',
              name: 'internalNotes',
              label: 'Internal Notes',
            },
          ],
        }
      : undefined;

  // $FlowFixMe
  const fieldSet = compact([
    {
      columns: { small: 1, large: 1 },
      fields: [
        {
          type: 'locationAutocomplete',
          name: 'locationRaw',
          label: 'Location',
        },
      ],
    },
    {
      columns: { small: 1, large: 1 },
      fields: [
        {
          disabled: isScheduling(sessionDate, endTime) && isRecurring,
          type: 'checkbox',
          name: 'isCancelation',
          label: 'This is for a canceled session',
        },
      ],
    },
    internalNotes,
  ]);

  return [
    {
      fieldSet,
    },
  ];
};



// WEBPACK FOOTER //
// ./src/containers/sessions/create/form/fieldset.js